<template>
    <div class="overflow-hidden">
        <section class="bg-black pb-44 text-white at1024:pb-[470px]">
            <div id="brand-hero-wrapper" class="h-[5000px]">
                <div class="h-screen overflow-hidden relative">
                    <h1
                        id="brand-hero-text"
                        class="absolute leading-none left-1/2 max-w-[545px] mx-auto opacity-0 scale-50 text-[40px] text-center top-[calc(50%-75px)] -translate-x-1/2 -translate-y-1/2 w-3/4 at1024:text-[80px]"
                    >
                        We’ve changed.
                        <span class="text-gray-400"
                            >But we’re still the same, too.</span
                        >
                    </h1>
                    <svg
                        id="brand-hero-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="512"
                        height="512"
                        viewBox="0 0 512 512"
                        class="absolute h-50 left-1/2 text-red top-[calc(50%-75px)] -translate-x-1/2 -translate-y-1/2 w-50"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M184.261 169.077h-64.454c0 2.901-.341 5.689-.341 8.818 0 68.265 44.202 91.59 122.536 110.476 66.787 15.417 82.26 29.354 83.114 54.954h64.624v-4.438c0-61.552-40.504-89.427-118.327-108.087-70.484-17.066-87.323-29.468-87.323-58.367.057-1.308.114-2.332.171-3.356ZM254.631.002c103.663-.549 197.427 61.47 237.48 157.085 40.055 95.614 18.491 205.945-54.615 279.443-73.105 73.497-183.32 95.65-279.147 56.109C62.523 453.097 0 359.666 0 256.002-.314 115.022 113.652.445 254.631.002Z"
                        />
                    </svg>
                </div>
            </div>
            <div id="brand-shape-wrapper" class="px-4 at1024:px-8">
                <p
                    class="font-bold leading-[1.2] max-w-[545px] mb-10 mx-auto text-[28px] at1024:mb-[90px] at1024:text-[35px]"
                >
                    For nearly 40 years, we’ve become the door hardware and
                    security leader.
                    <span class="text-gray-400"
                        >Being a leader means moving forward. So we’ve enhanced
                        our brand, as we innovate in this rapidly changing
                        industry. For years, customers have called us SECLOCK,
                        just like our website. Now SECLOCK is our official name
                        — efficient, inviting and customer friendly.</span
                    >
                </p>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1087"
                    height="148"
                    viewBox="0 0 608.49 82.36"
                    class="mx-auto"
                >
                    <path
                        class="seclock-outline"
                        d="M34.18,81.86C51,81.86,62.85,73,62.85,58.13c0-13.22-8.83-19.21-25.8-23.28-15.37-3.62-19-6.33-19-12.54,0-5.31,4.82-9.49,13.08-9.49,7.33,0,14.56,2.82,21.78,8.13l7.57-10.51A44.91,44.91,0,0,0,31.31.5C15.38.5,3.91,9.77,3.91,23.55c0,14.69,9.63,19.66,26.72,23.73,14.9,3.39,18.11,6.44,18.11,12.2,0,6.1-5.5,10.06-14.21,10.06-10,0-17.66-3.73-25.35-10.28L.7,69.2A49.88,49.88,0,0,0,34.18,81.86Z"
                    ></path>
                    <polygon
                        class="seclock-outline"
                        points="148.72 80.73 148.72 68.3 103.33 68.3 103.33 47.05 143.06 47.05 143.06 34.62 103.33 34.62 103.33 14.06 148.16 14.06 148.16 1.63 89.4 1.63 89.4 80.73 148.72 80.73"
                    ></polygon>
                    <path
                        class="seclock-outline"
                        d="M210.73,81.86c14.92,0,24-5.4,32.34-13.94l-9-9c-6.84,6.29-13.1,10.23-22.89,10.23-15.26,0-26.31-12.59-26.31-28.09S195.93,13.2,211.19,13.2c9.11,0,15.94,3.93,22.32,9.77l9-10.22C234.87,5.56,226,.5,211.3.5c-24.14,0-41.11,18.32-41.11,40.79C170.19,64,187.5,81.86,210.73,81.86Z"
                    ></path>
                    <polygon
                        class="seclock-outline"
                        points="327.25 80.73 327.25 68.07 285.33 68.07 285.33 1.63 271.32 1.63 271.32 80.73 327.25 80.73"
                    ></polygon>
                    <path
                        class="seclock-outline"
                        d="M381,69.16c-15.88,0-27.19-12.7-27.19-28.09s11.08-27.87,27-27.87S408,25.9,408,41.29,396.92,69.16,381,69.16Zm-.23,12.7c24.56,0,41.92-18.55,41.92-40.79S405.6.5,381,.5,339.12,19,339.12,41.29,356.25,81.86,380.81,81.86Z"
                    ></path>
                    <path
                        class="seclock-outline"
                        d="M481.35,81.86c14.92,0,24-5.4,32.34-13.94l-9-9c-6.84,6.29-13.1,10.23-22.89,10.23-15.26,0-26.31-12.59-26.31-28.09S466.55,13.2,481.81,13.2c9.11,0,15.94,3.93,22.32,9.77l9-10.22C505.49,5.56,496.61.5,481.92.5c-24.14,0-41.11,18.32-41.11,40.79C440.81,64,458.12,81.86,481.35,81.86Z"
                    ></path>
                    <polygon
                        class="seclock-outline"
                        points="550.87 80.73 550.87 57.79 563.28 45.13 590.5 80.73 607.48 80.73 572.85 35.64 606 1.63 588.8 1.63 550.87 41.4 550.87 1.63 536.86 1.63 536.86 80.73 550.87 80.73"
                    ></polygon>
                </svg>
            </div>
        </section>
        <section class="bg-gray-100 relative">
            <BaseSvg
                name="ShapeSNickel"
                class="absolute -left-72 opacity-[0.4] top-[300px] w-[1300px] at1024:left-[180px] at1024:top-0 at1024:w-[2300px]"
            />
            <div
                class="relative -mb-24 -top-24 text-center at1024:-mb-64 at1024:-top-64"
            >
                <div
                    class="wrap wrap-large max-h-[188px] overflow-hidden relative at768:max-h-[375px] at1024:max-h-[531px]"
                >
                    <img
                        src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/home_bg_0003"
                        height="531"
                        width="1090"
                        sizes="1090px"
                        loading="lazy"
                        alt="Our brand introduction video"
                    />
                    <button
                        class="absolute bg-white flex h-23 items-center justify-center left-1/2 rounded-full top-1/2 -translate-x-1/2 -translate-y-1/2 w-23 hover:bg-gray-150"
                        @click="
                            toggleVideoDialog(
                                event,
                                'https://player.vimeo.com/video/519141557?autoplay=1'
                            )
                        "
                    >
                        <span
                            class="block border-[18px] border-l-[32px] border-l-black border-y-transparent border-r-0 h-8 translate-x-1 w-8"
                        ></span>
                        <span class="sr-only">Play video</span>
                    </button>
                </div>
            </div>
            <div
                class="wrap wrap-huge h-72 relative at1024:h-80"
                aria-hidden="true"
            >
                <img
                    src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/about_work_4"
                    class="absolute hidden at1024:inline at1024:right-4 at1024:-top-80"
                    height="200"
                    width="200"
                    sizes="200px"
                    loading="lazy"
                    alt=""
                />
                <img
                    src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/brand_work_1"
                    class="absolute h-40 -left-20 top-16 w-40 at1024:h-[315px] at1024:left-12 at1024:-top-14 at1024:w-[315px]"
                    height="315"
                    width="315"
                    sizes="315px"
                    loading="lazy"
                    alt=""
                />
                <img
                    src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/brand_work_2"
                    class="absolute bottom-0 h-24 right-2 w-24 at1024:h-[200px] at1024:right-28 at1024:w-[200px]"
                    height="200"
                    width="200"
                    sizes="200px"
                    loading="lazy"
                    alt=""
                />
            </div>
            <div
                class="wrap wrap-large mt-14 relative at1024:mt-20"
            >
                <h2
                    class="bg-gray-100 font-bold leading-none text-[40px] text-center text-gray tracking-[-0.4px] at480:mx-auto at480:w-80 at1024:mb-[90px] at1024:mx-0 at1024:text-[80px] at1024:text-left at1024:w-112"
                >
                    On this path with our customers.
                </h2>
                <div
                    class="my-[90px] text-center at1024:float-left at1024:ml-20 at1024:my-0 at1200:ml-32"
                    aria-hidden="true"
                >
                    <base-svg
                        name="seclock-icon"
                        class="h-44 w-44 at1024:h-88 at1024:w-88"
                    />
                </div>
                <div
                    class="at600:mx-auto at600:w-[540px] at1024:max-w-[1116px] at1024:w-auto"
                >
                    <p
                        class="bg-gray-100 font-bold leading-[1.2] mb-24 text-[28px] text-gray-400 at1024:ml-[480px] at1024:text-[35px] at1200:ml-[590px]"
                    >
                        <span class="text-gray"
                            >We also updated our logo. It features a red circle
                            with a line inside that we call The Path.</span
                        >
                        It’s about the connection we have with customers. It
                        shows how we’re their one-stop shop, quickly connecting
                        them to the right solutions, and how we’re here every
                        step of the way.
                    </p>
                    <p
                        class="bg-gray-100 font-bold leading-[1.2] text-[28px] text-gray-400 at1024:text-[35px] at1024:ml-14 at1024:w-[455px]"
                    >
                        <span class="text-gray"
                            >Brand enhancements go beyond our name and
                            logo.</span
                        >
                        We’re constantly rolling out new tools to keep our
                        website and customer support at this industry’s cutting
                        edge.
                    </p>
                </div>
            </div>
            <div
                class="wrap wrap-compact mt-36 pb-24 relative at1024:pb-40"
            >
                <h3
                    class="absolute font-bold left-0 leading-none opacity-0 text-[80px] text-center text-gray-300 top-24 w-full z-20 at768:opacity-100"
                >
                    What will never change.
                </h3>
                <div class="relative z-10">
                    <img
                        src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/brand_change"
                        class="mb-[86px]"
                        height="845"
                        width="830"
                        sizes="830px"
                        loading="lazy"
                        alt=""
                        aria-hidden="true"
                    />
                    <p
                        class="bg-gray-100 font-bold leading-[1.2] text-[28px] text-center text-gray-400 at1024:text-[35px]"
                    >
                        <span class="text-gray"
                            >As we move forward, many things about SECLOCK will
                            never change.</span
                        >
                        Like our unmatched, in-stock inventory featuring the industry’s leading premium manufactures. Same-day shipping so you get what
                        you need fast. Expert support from our technical sales
                        reps so you always have information you need. And all
                        the other ways we’ve built enduring customer loyalty and
                        partnerships.
                    </p>
                    <p
                        class="font-bold leading-[1.2] mt-[60px] text-[28px] text-center text-gray at1024:leading-[1.1] at1024:text-4xl"
                    >
                        This is the path we’re on, together.
                        <span class="block text-red"
                            >Here’s to the next 40 years.</span
                        >
                    </p>
                    <div class="mt-[60px] text-center" aria-hidden="true">
                        <base-svg
                            name="seclock-logo-horiz-gray"
                            class="w-[195px]"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
    <Meta
        title="The Path We Are On | Commercial Door Distributor"
        description="As we move forward, many things about SECLOCK will never change. Like our unmatched, in-stock inventory featuring the industry’s leading premium manufactures."
    />
</template>

<script setup>
import {onBeforeUnmount, onMounted} from "vue";
import { BaseSvg, Meta } from "@/Components";
import { useVideoDialog } from "@/Composables";
import { gsap } from "gsap";
import  ScrollTrigger  from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const { toggleVideoDialog } = useVideoDialog();

onMounted(() => {
    const headerHeight =
        document.documentElement.style.getPropertyValue("--header-height");

    if(import.meta.env.SSR) return;
    const tlHero = gsap.timeline();
    const tlShape = gsap.timeline();

    tlHero
        .add("timelineStart")
        .to("#brand-hero-icon", { scale: 30, opacity: 0 }, "timelineStart")
        .to("#brand-hero-text", { scale: 1, opacity: 1 }, "timelineStart+=4%");

    ScrollTrigger.create({
        animation: tlHero,
        trigger: "#brand-hero-wrapper",
        pin: true,
        pinSpacing: false,
        start: "top 121",
        end: "bottom 75%",
        scrub: 0.25,
        // markers: true, // Debug markers
    });

    tlShape.to(".seclock-outline", { fill: "#97999b" });

    ScrollTrigger.create({
        animation: tlShape,
        trigger: "#brand-shape-wrapper",
        start: "bottom 75%",
        end: "bottom 25%",
        scrub: 0.25,
        // markers: true, // Debug markers
    });

    // This stinks, but there's a bug in Safari without it.
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 1);
});

onBeforeUnmount(()=>{
    if(import.meta.env.SSR) return;
    ScrollTrigger.getAll().forEach((trigger) => {
        trigger.kill();
    });
});
</script>

<style>
/* This is necessary for the SECLOCK animated SVG above: */
.seclock-outline {
    fill: #000;
    stroke: #97999b;
    stroke-miterlimit: 10;
}
</style>
